export default __webpack_public_path__ + "static/media/operacionais.6311b77b.svg";